export const environment = {
  backendBaseURL: 'https://us-central1-orderax-store.cloudfunctions.net',
  siteBaseURL:  'https://orderax.com',
  clientId: '861906427287-a452a97rn7sb8nbn8v8rh7qvrdbfv7ia.apps.googleusercontent.com',
  production: true,
  
};
